module.exports = __webpack_public_path__ + "img/fileediticon.0cefada0.svg";